import { render, staticRenderFns } from "./MediaSection.vue?vue&type=template&id=c38edb76&"
import script from "./MediaSection.vue?vue&type=script&lang=js&"
export * from "./MediaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports